export default __webpack_public_path__ + "static/platform-pdf-viewer-d099e7ade447afbc09d31cbced67541a.png";